import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_breadcrumb, {
      size: "is-large",
      separator: "has-succeeds-separator",
      "aria-label": "breadcrumbs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_breadcrumb_item, {
          tag: "a",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToList()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('projects.title')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_b_breadcrumb_item, { active: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_field, {
        label: _ctx.$t('projects.name')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_input, {
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
            placeholder: _ctx.$t('projects.namePlaceholder')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_b_button, {
          type: "is-primary",
          loading: _ctx.saving,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.create()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('projects.create')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_b_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToList()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('global.cancel')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}